import { AfterViewInit, Component, DoCheck, ElementRef, OnChanges, OnDestroy, OnInit, Renderer2, SimpleChanges, ViewChild } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/API/api.service';
import { CacheService } from 'src/app/shared/services/Cache/cache.service';
import { Company, ConnectionService } from 'src/app/shared/services/Connection/connection.service';
import { UserService } from 'src/app/shared/services/User/user.service';
import { typeInterface } from 'src/app/shared/Interfaces/company';
import { Cliente } from 'src/app/shared/Interfaces/customer';
import IMask from 'imask';
import { LayoutComponent } from 'src/app/shared/layout/layout.component';
import { Subscription } from 'rxjs';
import { OrderService } from 'src/app/shared/services/Order/order.service';
@Component({
  selector: 'app-user-data',
  templateUrl: './user-data.component.html',
  styleUrls: ['./user-data.component.css']
})
export class UserDataComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('inputPhone') inputPhone!: ElementRef;
  @ViewChild('inputName') inputName!: ElementRef;
  @ViewChild('inputBirth') inputBirth!: ElementRef;

  //#region Variaveis de Estilo
    isChecked: boolean = false;
    foundUser = false;
    lengthInputName: any;
    lengthInputPhone = false;
    lengthInputBirth = true;
    editUser = false;
    corretFormatPhoneNumber: any;
    correctFormatBirth: any
    requiredBirth = false;
  //#endregion

  //#region Variaveis Locais
    private typeParam!: typeInterface;
    private nameCompany: string = '';
    private phoneMask: any;
    private birthMask: any;
    private userSubscription: Subscription;

    phoneNumberPattern = /^\(\d{2}\)\d{5}\-\d{4}$/;
    userRequest!: Cliente | undefined;
    user!: Cliente;
    id_customer: string = '';
    name: string = '';
    phoneNumber: string = '';
    birthData: string = '';
    company!: Company;
    submit: boolean = false;


  //#endregion

  //#region Inicializadores

    constructor(
      private router: Router,
      private apiService: ApiService,
      private cacheService: CacheService,
      private connection: ConnectionService,
      private layout: LayoutComponent,
      private userService: UserService,
      private location: Location,
      private renderer: Renderer2,
      private elementRef: ElementRef,
      private orderService: OrderService
      ){
        this.connection.nameCompany$.subscribe((newNameCompany) => {
          this.nameCompany = newNameCompany;
        })

        this.userService.editingUser$.subscribe((newvalue) =>{
          this.foundUser = newvalue
        })

        this.connection.typeParam$.subscribe((newType) => {
          this.typeParam = newType
        })

        this.connection.company$.subscribe((newCompany) =>{
          this.company = newCompany

          if(this.company.company.id_company.toString() == 'f33fcb89-4d42-4745-b090-212cd6f359bd'){
            this.requiredBirth = true;
          }
        })

        this.userSubscription = this.connection.user$.subscribe(
          (data) =>{
            if(data){
              this.user = data
              this.phoneNumber = this.user.phone
              this.name = this.user.name,
              this.birthData = this.user.birthDate

              this.getUserIsPhone(this.phoneNumber);

              if(this.phoneMask && this.birthMask)
              {
                setTimeout(() => {
                  this.phoneMask.updateValue();
                  this.birthMask.updateValue();
                  console.log('Mask atualizado:', {phone: this.phoneMask, birth: this.birthMask})
                }, 0);

              }
            }
          }
        )
    }

    ngOnInit(): void {
      this.disablePullToRefresh()

      this.layout.checkScreenSize();

      this.validator();

    }

    ngAfterViewInit(): void {

      setTimeout(() => {
        this.phoneMask = IMask(this.inputPhone.nativeElement, {
          mask: '(00)00000-0000',
        });
        this.birthMask = IMask(this.inputBirth.nativeElement, {
          mask: '00/00/0000',
        });
        this.phoneMask.updateValue();
        this.birthMask.updateValue();
        console.log('Mask aplicado:', {phone: this.phoneMask, birth: this.birthMask})
      }, 0);

      
    }

    ngOnDestroy(): void {
      if (this.userSubscription) {
        this.userSubscription.unsubscribe();
      }
    }

  //#endregion

  //#region Funções de Estilo (Style)

    //Função responsavel por travar de o scroll para que a tela não seja recarregada no menu
    disablePullToRefresh() {
      const element = this.elementRef.nativeElement;
      let isAtTop = true;

      // Adiciona um ouvinte para o evento de scroll
      this.renderer.listen(window, 'scroll', () => {
        // Verifica se a página está no topo
        isAtTop = window.scrollY === 0;
      });

      this.renderer.listen(element, 'touchstart', (event) => {
        // Registra a posição inicial do toque
        const startY = event.touches[0].clientY;

        // Adiciona um ouvinte para o evento de movimento de toque
        const touchMoveListener = this.renderer.listen(element, 'touchmove', (moveEvent) => {
          // Calcula a diferença entre a posição inicial e a posição atual
          const deltaY = moveEvent.touches[0].clientY - startY;

          // Se a diferença for positiva (movimento para baixo) e a página estiver no topo, previne o comportamento padrão
          if (deltaY > 0 && isAtTop) {
            moveEvent.preventDefault();
          }
        });

        // Adiciona um ouvinte para o evento de término de toque
        const touchEndListener = this.renderer.listen(element, 'touchend', () => {
          // Remove os ouvintes após o término do toque
          touchMoveListener();
          touchEndListener();
        });
      });
    }

    validator(){
      if(this.phoneNumber.length === 14){
        this.foundUser = true;
        this.corretFormatPhoneNumber = true;
        this.lengthInputPhone = true;
      }
      if(this.name.length >= 3){
        this.lengthInputName = true;
      }
    }

  //#endregion

  //#region Funções de Lógica (Logic)

    //retorna a pagina anterior
    goback(): void{
      this.location.back()
    }

    //Acionado toda vez que uma letra é digitada no input do nome
    onInputChangeName(event:any)
    {
      const length = event.target.value.length
      if(length >= 3 )
      {
        this.lengthInputName = true;
      }
      else{
        this.lengthInputName = false;
      }

    }

    //Valida se o input está prenchido corretamente
    validateBirthDate() {
      this.birthData = this.birthData.replace(/[^0-9/]/g, '');
  
      const onlyNumbers = this.birthData.replace(/\D/g, ''); 

      if (this.birthData && this.birthData.length > 0) {
        // Verifica o tamanho da data
        this.correctFormatBirth = onlyNumbers.length === 8;
        
        if (this.correctFormatBirth) {
          // Extrai dia, mês e ano
          const day = Number(onlyNumbers.substring(0, 2));
          const month = Number(onlyNumbers.substring(2, 4));
          const year = Number(onlyNumbers.substring(4, 8));
          
          //Verifica se os valores são números válidos
          if (isNaN(day) || isNaN(month) || isNaN(year)) {
            this.correctFormatBirth = false;
            return;
          }
          
          // Cria um objeto Date
          const birthDate = new Date(year, month - 1, day);
          
          // Verifica se a data é válida
          const isValidDate = (birthDate.getFullYear() === year && birthDate.getMonth() === month - 1 && birthDate.getDate() === day);
          
          // Verifica se a data está em um intervalo razoável de 120 anos
          const currentYear = new Date().getFullYear();
          const minYear = currentYear - 120;
          const maxYear = currentYear; // Não pode ser no futuro
          
          this.correctFormatBirth = isValidDate && year >= minYear && year <= maxYear;
        }
        
        this.lengthInputBirth = onlyNumbers.length === 8;
      } else {
        this.correctFormatBirth = undefined;
        this.lengthInputBirth = true;
      }
    }

    //#region Phone Number

      //Formata e valida o telefone do usuário
      formatPhoneNumber(phone: string): string {
        if (!phone) return '';
      
        let rawValue = phone.replace(/\D/g, '');
      
        const firstPart = rawValue.substring(0, 2);
        const secondPart = rawValue.substring(2, 7);
        const thirdPart = rawValue.substring(7, 11);
      
        if (rawValue.length <= 2) {
          return `(${firstPart}`;
        } else if (rawValue.length <= 7) {
          return `(${firstPart})${secondPart}`;
        } else {
          return `(${firstPart})${secondPart}-${thirdPart}`;
        }
      }
  
      //Valida se o input está prenchido corretamente
      validatePhoneNumber() {
        if(this.phoneNumber.replace(/\D/g, '').length > 0){
          this.corretFormatPhoneNumber = this.phoneNumber.replace(/\D/g, '').length === 11;
  
          if(this.phoneNumber.replace(/\D/g, '').length < 11){
            this.lengthInputPhone = false;
          }
          else{
            this.lengthInputPhone = true;
            this.phoneNumber = this.formatPhoneNumber(this.phoneNumber);
            this.getUserIsPhone(this.phoneNumber)
          }
        }
        else{
          this.corretFormatPhoneNumber = undefined;
          this.lengthInputPhone = false;
        }
      }

      //Busca o usuario pelo seu telefone
      getUserIsPhone(phoneNumber: string){
        let formatted = this.formatPhoneNumber(phoneNumber);

        if(formatted.length === 14){
          this.apiService.getUsuario(formatted).subscribe(
            (data) => {
              this.handleSuccessfulResponse(data);
            },
            (error) => {
              console.log('Usuario não cadastrado');
              this.handleError(error)
            }
          )
        }
      }

    //#endregion


    //#region Confirm
      
      //Assim que confirmado ele monta os objetos necessarios com os valores dos campos
      submitForm(){
        if(this.lengthInputName && this.lengthInputPhone && this.lengthInputBirth){
          this.submit = true;
          // let user = this.cacheService.getItemLocal('user_key');
          let userAddress = this.cacheService.getItemLocal('Address_Saved');

          //Valida e remove os endereços salvos em cache.
          if(userAddress)
          {
            this.cacheService.removeItemLocal('Address_Saved')
          }

          //Valida se o usuário já existe e se foi feita alterações
          if(this.userRequest)
          {
            if(this.userRequest.name != this.name || this.userRequest.phone != this.phoneNumber || this.userRequest.birthDate != this.birthData)
            {
              this.editUser = true;
              if(this.id_customer != this.userRequest.id_customer){
                this.id_customer = this.userRequest.id_customer
              }

            }
          }
    
          //Formata o numero de telefone, antes de enviar para base
          this.phoneNumber = this.formatPhoneNumber(this.phoneNumber);

          //Resgata o document, caso tenha.
          let document = '';
          if(this.userRequest){
            document = this.userRequest.document ?? '';
          }

          //Monta o objeto de usuário
          let cliente: Cliente = {
            name: this.name,
            phone: this.phoneNumber,
            id_customer: this.id_customer,
            document: document,
            birthDate: this.birthData
          }
    
          //Caso sejá o cadastro de usuario
          if(this.foundUser == false)
          {
            this.apiService.postUsuario(cliente).subscribe(
              (data) => {
                console.log('Usuario cadastrado com sucesso:', data);

                //Carrega com o novo id
                cliente.id_customer = data.response.Customer.id_customer;
    
                //Insere localmente
                this.cacheService.setItemLocal('user_key', cliente)
                
                //Realiza a requisição do usuário novamente
                this.connection.getUser(this.company.company.id_company);
    
                //Navega até a proxima view
                this.navegation();
    
              },
              (error) => {
                console.error('Erro ao cadastrar usuario:', error);
                this.apiService.getUsuario(this.phoneNumber).subscribe(
                  (data) => {
                    this.handleSuccessfulResponse(data)
                  },
                  (error) => {
                    this.handleError(error)
                  }
                )
              }
            );
    
          }
          else{
            //Caso necessite editar as informações do usúario
            if(this.editUser){
              this.pathUser();
            }
            //Caso resgatou e não precisa editar
            else{
              this.cacheService.setItemLocal('user_key', cliente);
                    
              this.connection.getUser(this.company.company.id_company);

              this.navegation();
            }
          }
        }
      }

      //Edita o usuario
      pathUser(){
        this.apiService.patchUser(this.id_customer, this.name, this.phoneNumber, this.birthData).subscribe(
          (data) =>{

            let cliente: Cliente = {
              phone: data.response.phone,
              id_customer: data.response.id_customer,
              name: data.response.name,
              document: data.response.document,
              birthDate: data.response.birthDate
            }

            this.cacheService.setItemLocal('user_key', cliente);

            this.connection.getUser(this.company.company.id_company);

            this.navegation();

          },
          (error) =>{
            console.log('Erro ao editar usuario:')
          }
        )
      } 

      //Função para lidar com a resposta bem-sucedida
      private handleSuccessfulResponse(data: any): void {

        //Carrega as informações do Usuário
        const customer = data.response.customer;
        this.name = customer.name;
        this.birthData = customer.birthDate
        this.id_customer = customer.id_customer;

        //Abilita e valida as veriaveis visuais
        this.foundUser = true;
        this.lengthInputName = true;
        this.lengthInputPhone = true;
        this.corretFormatPhoneNumber = true;
        this.validateBirthDate();

        //Atualiza as mascaras
        this.birthMask.value = this.birthData;

        //Carrega as propriedades da requisição
        const userKey = {
          phone: customer.phone,
          id_customer: customer.id_customer,
          name: customer.name,
          birthDate: customer.birthDate,
          document: customer.document
        }
        this.userRequest = userKey;

        //Retira o foco do input de número
        this.inputPhone.nativeElement.blur();
      }

      //Função para lidar com erros
      private handleError(error: any): void {

        this.userRequest = undefined;
        this.name = '';
        this.foundUser = false;
        if(this.name.length >= 3)
        {
          this.lengthInputName = true;
        }
        else{
          this.lengthInputName = false;
        }

        this.inputPhone.nativeElement.blur();
        this.inputName.nativeElement.focus();
      }

      navegation(){
        setTimeout(() => {
          if(this.typeParam.type == 3)
          {
            this.router.navigate([this.nameCompany, 'order-confirmation-counter']);
          }
          else{
            this.router.navigate([this.nameCompany, 'order-confirmation']);
          }
        }, 500);
      }

    //#endregion

  //#endregion

}

